import { ContainerComponent } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { csvData, exportFileName } from './utils';
import ExportDropdown from '../exportDropdown';

export const definition = {
  name: 'ExportInspections',
  controller: Controller,
  initialProps: ({ startDate, endDate, inspections, status, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds }) =>
  ({
    startDate, endDate, inspections, status, searchTerms,
    properties, groups, selectedPropertyIds, selectedGroupIds,
    fileName: exportFileName({ startDate, endDate, status }),
    data: csvData({ status, inspections })
  }),
  props: internalState,
  elements: [
    {
      component: ExportDropdown,
      name: 'ExportDropdown',
      bindings: ({ action, startDate, endDate, inspections, status, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds, fileName, data }) => ({
        csvData: data, fileName, showSubscribe: true,
        action, startDate, endDate, inspections, status, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds, fileName
      })
    },
  ]
}

export default ContainerComponent(definition);